import { FC } from 'react';
import MDBox from '@components/MDBox';
import {
  TableRow,
  TableBody,
  Collapse,
  TableContainer,
  Table
} from '@mui/material';
import { parseJSON } from '@utils/common';
import { getLabelColor } from '@utils/cleaning';

import DataTableBodyCell from './DataTableBodyCell';
import DataTableHeadCell from './DataTableHeadCell';

interface ICleanedTypeTableProps {
  open: boolean;
  clientWidth?: number;
  data: any[];
}
export interface CleanedJSON {
  columns: string[];
  data: Array<Array<number | null | string>>;
}

const TableWrapper: FC<{ data: string; cleanLabel: string }> = ({
  data,
  cleanLabel
}) => {
  const parsedData = parseJSON<CleanedJSON>(data);
  const labelColor = getLabelColor(cleanLabel);


  return (
    <TableContainer
      sx={{
        boxShadow: 'none',
        maxHeight: '385px',
        borderRadius: '5px',
        border: `2px solid ${labelColor}`,
        height: 'fit-content',
        overflow: 'auto',
        width: '380px'
      }}
    >
      <Table>
        <TableRow
          sx={{
            position: 'sticky',
            top: 0,
            background: 'white',
            outline: `2px solid ${labelColor}`
          }}
        >
          {parsedData?.columns.map((heading) => (
            <DataTableHeadCell key={heading} border={`1px solid ${labelColor}`}>
              {heading}
            </DataTableHeadCell>
          ))}
        </TableRow>

        <TableBody>
          {parsedData?.data.map((row) => (
            <TableRow key={row[0]}>
              {row?.map((column) => (
                <DataTableBodyCell
                  key={column}
                  border={`1px solid ${labelColor}`}
                  noBorder
                >
                  {column}
                </DataTableBodyCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const CleanedTypeTable: FC<ICleanedTypeTableProps> = ({
  open,
  clientWidth,
  data
}) => {
  const cleanLabels = Object.keys(data);

  return (
    <TableRow>
      <DataTableBodyCell colspan={8}>
        <Collapse in={open} unmountOnExit>
          <MDBox
            ml={4}
            my={2}
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '20px',
              width: (clientWidth || 1250) - 350 + 'px'
            }}
          >
            {Object.values(data).map((value, index) => (
              <TableWrapper
                data={value}
                key={cleanLabels[index]}
                cleanLabel={cleanLabels[index]}
              />
            ))}
          </MDBox>
        </Collapse>
      </DataTableBodyCell>
    </TableRow>
  );
};

export default CleanedTypeTable;
